document.addEventListener('DOMContentLoaded', () => {
  let lang = document.documentElement.lang;

  //EMAIL VALIDATION REGISTER
  const loginemailInput = document.getElementById('RegisterForm-email');
  const loginemailError = document.getElementById('email-error');
  const loginsubmitButton = document.getElementById('register__button');
  let validEmail = false;
  let validPassword = false;
  let validCheckbox = false;
  
  loginemailInput.addEventListener('focus', () => {
    const emailValue = loginemailInput.value.trim();
    if (emailValue === '' || !isValidEmail(emailValue)) {
      if (lang === 'pl') {
        loginemailError.textContent = 'Wprowadź poprawny email';
    } else if (lang === 'en') {
        loginemailError.textContent = 'Type a valid email address';
    }
      
      loginemailInput.classList.add('error-border');
      validEmail = false;
    } else {
      loginemailError.textContent = '';
      loginemailInput.classList.remove('error-border');
      validEmail = true;
    }
  });

  loginemailInput.addEventListener('input', () => {
    const emailValue = loginemailInput.value.trim();
    if (emailValue === '' || !isValidEmail(emailValue)) {
      if (!loginemailInput.classList.contains('error-border')) {
        loginemailInput.classList.add('error-border');
      }
      if (lang === 'pl') {
        loginemailError.textContent = 'Wprowadź poprawny email';
    } else if (lang === 'en') {
        loginemailError.textContent = 'Type a valid email address';
    }
      validEmail = false;
    } else {
      loginemailError.textContent = '';
      loginemailInput.classList.remove('error-border');
      validEmail = true;
    }
  });
  
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  //PASSWORD VALIDATION REGISTER
  const passwordInput = document.getElementById("RegisterForm-password");
  const passwordError = document.getElementById("password-error");

  function validatePassword() {
    const password = passwordInput.value;
    const minLength = 5;
  
    if (password.length < minLength) {
      passwordInput.classList.add("error-border");
      if (lang === 'pl') {
        passwordError.textContent = 'Hasło musi zawierać co najmniej 5 znaków';
    } else if (lang === 'en') {
        passwordError.textContent = 'The password must contain at least 5 characters';
    }
      validPassword = false;
    } else {
      passwordInput.classList.remove("error-border");
      passwordError.textContent = '';
      validPassword = true;
    }
  }
  
  passwordInput.addEventListener("input", validatePassword);
  passwordInput.addEventListener("focus", validatePassword);

  //CHECKBOX TERMS VALIDATION
  const termsCheckbox = document.getElementById("termsCheckbox");

  termsCheckbox.addEventListener("change", () => {
    validCheckbox = termsCheckbox.checked;
    enableButton();
  });

  function enableButton() {
    
    if (validPassword == true && validEmail == true && validCheckbox == true) {
      loginsubmitButton.disabled = false;
    } else {
      loginsubmitButton.disabled = true;
    }
  }

  passwordInput.addEventListener("input", enableButton);
  passwordInput.addEventListener("focus", enableButton);
  loginemailInput.addEventListener("input", enableButton);
  loginemailInput.addEventListener("focus", enableButton);


  //SUBMIT REGISTER VALIDATION
  const sourceParamRegister = new URLSearchParams(window.location.search).get('source');

  if (sourceParamRegister === 'existing-email') {
    if (lang === 'pl') {
        loginemailError.textContent = 'Użytkownik z podanym emailem już istnieje';
    } else if (lang === 'en') {
        loginemailError.textContent = 'The user with the given email address already exists';
    }
    
    loginemailInput.classList.add('error-border');

    loginemailInput.addEventListener('focus', () => {
      loginemailInput.textContent = '';
    });
  }
});


